import { withOnClickTracking } from 'auto-tracking';

import { styled, theme } from '../stitches.config';

export const basicButtonStyles = {
  cursor: 'pointer',
  appearance: 'none',
  border: 'unset',
  backgroundColor: 'unset',
  color: 'unset',
  fontFamily: theme.fonts.sansSerif,
  fontSize: 'inherit',
  padding: 0,
  margin: 0,

  '&:focus-visible': {
    boxShadow: `${theme.shadows.shadow3} ${theme.colors.yellowAlpha7}`,
    outline: `2px solid ${theme.colors.yellow8}`,
    outlineOffset: '2px',
  },

  '&:active': {
    boxShadow: 'unset',
    outline: 'unset',
  },

  '&:disabled, &[aria-disabled="true"]': {
    cursor: 'unset',
    boxShadow: 'unset',
    outline: 'unset',
  },
};

export const BasicButton = withOnClickTracking(
  styled('button', { ...basicButtonStyles }),
);
